import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flush", "onBoarding", "testId", "enclosed"];
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SidebarSection = props => {
  const {
      children,
      flush,
      onBoarding,
      testId,
      enclosed
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    paddingInline: flush ? '0' : '500',
    paddingBlockEnd: "500",
    backgroundColor: enclosed ? 'border-core-subtle' : undefined,
    "data-onboarding": onBoarding || '',
    "data-test-id": testId || ''
  }, rest, {
    children: children
  }));
};
export default SidebarSection;